export default __webpack_public_path__ + "static/media/pantry1-afterE-1920w.72986ea8.webp";